import type { ComponentProps } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import type { HeightProps, MaxHeightProps } from 'styled-system';
import { height, maxHeight } from 'styled-system';

import YouTubeVideo from 'common/components/YouTubeVideo';
import type { SetVideoPlayer } from 'common/components/YouTubeVideo/hooks';
import type { ResponsiveImageWidths } from 'common/types/Image';

interface VideoProps {
  src: string;
  alt: string;
  isActive?: boolean;
  setVideoPlayer: SetVideoPlayer;
  widths?: ResponsiveImageWidths;
}

const StyledYoutubeVideo = styled(YouTubeVideo)<HeightProps & MaxHeightProps>`
  iframe {
    ${height};
    ${maxHeight};
  }
`;

const youTubeVideoStyles: Partial<ComponentProps<typeof StyledYoutubeVideo>> = {
  maxHeight: ['90vw', '100%'],
};

const Video = ({ src, alt, isActive = false, setVideoPlayer, widths }: VideoProps) => (
  <StyledYoutubeVideo
    {...youTubeVideoStyles}
    data-testid="product-gallery-main-slide-video"
    id={src}
    alt={alt}
    isActive={isActive}
    isLazy={!isActive}
    setVideoPlayer={setVideoPlayer}
    widths={widths}
  />
);

export default Video;
